export const LUNA = 'luna';
export const URBANE = 'urbane';
export const LIANO = 'liano';
export const CONTURA = 'contura';
export const OPAL = 'opal';
export const CARE = 'care';
export const URBANEUNIVERSALACCESSORIES = 'urbane-universal-accessories';
export const HOMECARE = 'homecare';
export const COSMO = 'cosmo';
export const ELEGANCE = 'elegance';
export const CIRRUS  = 'cirrus';
export const SAHARA  = 'sahara';
export const ACACIA  = 'acacia';
export const CLEANFLUSH = 'cleanflush';
export const EASYSWITCH = 'caroma-easy-switch';

export const PRODUCT_RANGES = [
    'Opal',
    'Opal II',
    'OpalCare',
    'OPALSUPPORT',
    'Opal II Easy Height',
    'Liano',
    'Liano Care',
    'Liano II',
    'Liano Nexus',
    'Liano Junior',
    'LIANOE',
    'Urbane',
    'Urbane II',
    'Contura',
    'Contura II',
    'Luna',
    'Urbane II Universal',
  ]; 